// Utility logger that can be used outside of React components
export const logger = {
    log: (apiName: string, message: string, customerID: string | null = null, status: 'success' | 'error', requestData: any = null) => {
        // Detect platform: mobile if URL contains mobile/view, otherwise web
        const platform = /mobile\/view/.test(window?.location?.href || '') ? 'mobile' : 'web';
        
        const logData = {
            zuid: document?.querySelector('body')?.getAttribute('zuid') || '',
            message,
            apiName,
            customerID,
            status,
            platform, // Add platform indicator
            requestData: requestData ? JSON.stringify(requestData) : null,
        };

        if(platform === 'web' && (apiName === 'API-Call-mobile-success' || apiName === 'API-Call-mobile-error')){
            return;
        }

        // Fire-and-forget fetch
        fetch('/schedule-and-save/api/log', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: logData ? JSON.stringify(logData) : null,
        })
    },

    logSuccess: ( message: string,apiName: string, customerID?: any | null, requestData?: any) => {
        logger.log(message,apiName,window['AB']['userInfo']['UUID'] || window['AB']['userInfo']['customerId'], 'success', requestData);
    },

    logError: (message: string, apiName: string, customerID?: any | null, requestData?: any) => {
        logger.log(message, apiName, window['AB']['userInfo']['UUID'] || window['AB']['userInfo']['customerId'], 'error', requestData);
    }
};
